import { API_URL } from 'constants';

export const DEFAULT_EMPLOYEE_TEAM_URL = `${API_URL}/api/v1/employeeteam`;
